import { useCallback, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { EConsentUserType, eConsentUserTypeToString } from "../../contexts/EConsentContext";
import { IConsentForm, IEvent, IInstitution, IPatient } from "../../api/dtos";
import { IFormAfterSubmit, OnlinePatientManagementContext } from "@ngt/opms";

const useEConsentFormAfterSubmit =  <TData extends IConsentForm = IConsentForm>(
    institution: IInstitution | null | undefined,
    patient: IPatient | null | undefined, 
    event: IEvent | null | undefined,
    user: EConsentUserType | null | undefined,
    consentGuid: string | null | undefined,
    onAfterSubmit?: IFormAfterSubmit<TData> | null,
    afterFormSave?: (institution?: IInstitution | null, patient?: IPatient | null, event?:  IEvent | null, form?: TData | null, user?: EConsentUserType | null, consentGuid?: string | null) => void,
    afterFormSaveAndReturn?: (institution?: IInstitution | null, patient?: IPatient | null, event?: IEvent | null, form?: TData | null, user?: EConsentUserType | null, consentGuid?: string | null) => void,
    patientRefresh?: () => Promise<IPatient | undefined>
) => {
    const params = useParams();
    const navigate = useNavigate();
    const { routeParameters, serviceStackClient } = useContext(OnlinePatientManagementContext);
    
    const onAfterSubmitToUse: IFormAfterSubmit<TData> = useCallback(async (newData, formState, formActions) => {
        if (onAfterSubmit) {
            const result = await onAfterSubmit(newData, formState, formActions);

            if (result !== undefined) {
                return result;
            }
        }

        if (patientRefresh) {
            await patientRefresh();
        }

        const { submitType } = formState.value as any
        if (submitType === 'save') {
            if (afterFormSave) {
                afterFormSave(institution, patient, event, newData, user);
            }
        }
        else if (afterFormSaveAndReturn) {
            afterFormSaveAndReturn(institution, patient, event, newData, user);
        }
        else {
            navigate(`/trial-consent/${eConsentUserTypeToString(user)}/econsent/${consentGuid}`)
        }
    }, [serviceStackClient, institution, patient, event, consentGuid, user, params, routeParameters, navigate, onAfterSubmit, patientRefresh])

    return onAfterSubmitToUse;
};

export default useEConsentFormAfterSubmit;